import { render } from "./Socials.vue?vue&type=template&id=03674e26&scoped=true"
import script from "./Socials.vue?vue&type=script&lang=js"
export * from "./Socials.vue?vue&type=script&lang=js"

import "./Socials.vue?vue&type=style&index=0&id=03674e26&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-03674e26"

export default script